import CustomModal, {CustomModalProps} from '@component/CustomModal';
import React, {useEffect, useRef, useState} from 'react';
import {useForm} from 'react-hook-form';

import {Button, message} from 'antd';
import {HttpStatusCode} from 'axios';
import {callChangePassword} from '@api/UserManagementApi';
import {ChangePassword, User} from '@interface/master/UserManagementIF';
import CustomValidFormInput from '@component/form/CustomValidFormInput';
import {useMessage} from '@hook/useMessage';

interface ChangePasswordPopupProps extends CustomModalProps {
    userInfo: User;
    onOk?: () => void;
    onCancel?: () => void;
}

const ChangePasswordPopup = (props:ChangePasswordPopupProps) => {
    const {control: changePasswordFormControl
        , register: changePasswordFormRegister
        , handleSubmit: changePasswordFormHandleSubmit
        , reset: changePasswordFormReset
        , setError: changePasswordFormSetError
    } = useForm<ChangePassword>({mode:'onSubmit'});
    const [info, setInfo] = useState<ChangePassword>({userSeq:props.userInfo?.userSeq, userId: props.userInfo?.userId, passwd:'', password_retry:''});
    const formRef = useRef<HTMLButtonElement>(null);
    const {alert} = useMessage();

    const handleSave = async(value:ChangePassword) => {
        if(value.passwd != value.password_retry) {
            changePasswordFormSetError('password_retry', { message:'패스워드가 일치하지 않습니다.'});
            return;
        }
        const result = await callChangePassword(info);
        if(result.code === HttpStatusCode.Ok) {
            await alert('비밀번호가 변경되었습니다.');
            handleReset();
            props.onOk && props.onOk();
        }  else {
            message.error(result.message);
        }

    };

    const handleReset = () => {
        setInfo({userSeq:-1, userId: '', passwd:'', password_retry:''});
        changePasswordFormReset();
    };

    useEffect(() => {
       props.userInfo&& setInfo(props.userInfo);
       props.userInfo&&changePasswordFormReset(props.userInfo);
    }, [props.userInfo, props.open]);

    return (
        <CustomModal  {...props}
                      onOk={() => {
                          formRef.current?.click();
                      }}
                      onCancel={() => {
                          handleReset();
                          props.onCancel && props.onCancel();
                      }}>
            <form onSubmit={changePasswordFormHandleSubmit(handleSave)}>
            <div>
                <p className={'full'}>
                    <span className="tit">{'사용자 ID'}</span>
                    <div className="box-inp">
                        <CustomValidFormInput
                            name={'userId'}
                            title={'사용자 ID'}
                            control={changePasswordFormControl}
                            disabled={true}
                            defaultValue={info?.userId ?? ''}
                        />
                    </div>
                </p>

                <p className={'full'}>
                    <span className="tit">{'변경할 비밀번호'}</span>
                    <div className="box-inp">
                        <CustomValidFormInput
                            title={'변경할 비밀번호'}
                            type={'password'}
                            control={changePasswordFormControl}
                            required={true}
                            onChangeValue={(v) => setInfo({...info, passwd: v})}
                            {...changePasswordFormRegister('passwd', {required: '비밀번호를 입력하세요.'})}
                        />
                    </div>
                </p>
                <p className={'full'}>
                    <span className="tit">{'비밀번호 확인'}</span>
                    <div className="box-inp">
                        <CustomValidFormInput
                            title={'비밀번호 확인'}
                            type={'password'}
                            control={changePasswordFormControl}
                            required={true}
                            {...changePasswordFormRegister('password_retry', {required: '비밀번호를 입력하세요.'})}
                        />
                    </div>
                </p>
            </div>
            <Button style={{display: 'none'}} ref={formRef}
                    onClick={changePasswordFormHandleSubmit(handleSave)}/>
        </form>
</CustomModal>
)
    ;
};

export default ChangePasswordPopup;